(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-lists-section"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.jQuery && jQuery.fn.owlCarousel) {
      $('.blog-lists-slider').owlCarousel({
        items: 1,
        loop: false,
        margin: 20,
        nav: true,
        dots: false,
        autoHeight: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          1000: {
            items: 1,
          }
        }
      });
      console.log('Owl Carousel initialized for .blog-lists-slider');
    } else {
      console.error('jQuery or Owl Carousel plugin is not loaded. Slider initialization failed.');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(){
  const tabLinks = document.querySelectorAll(".tab-link");
  const tabPanes = document.querySelectorAll(".tab-pane");

  tabLinks.forEach(link => {
    link.addEventListener("click", function(){
      let target = this.getAttribute("data-tab");
      
      tabLinks.forEach(l => l.classList.remove("active"));
      tabPanes.forEach(p => p.classList.remove("active"));

      this.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });

  // Initialize Swiper for each collection slider
  document.querySelectorAll(".collection-slider").forEach(slider => {
    new Swiper(slider, {
      slidesPerView: 2.5,
      spaceBetween: 5,
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },
       breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 5 },   // Tablets
        1024: { slidesPerView: 4, spaceBetween: 5 }   // Desktop: 4 products per row
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features-lists"] && !window.DesignMode) return;
  try {
    
$(document).ready(function () {
  document.addEventListener('DOMContentLoaded', function () {
      if (window.jQuery) {
          if (jQuery.fn.owlCarousel) {
              $('.product-features-lists-new').owlCarousel({
                  loop: false,
                  margin: 20,
                items:4,
                  nav: false,
                  dots: false,
                  responsive: {
                      0: {
                          items: 3.5
                      },
                      600: {
                          items: 3.5
                      },
                      1000: {
                          items: 4
                      }
                  }
              });
              console.log('Owl Carousel initialized for .product-features-lists');
          } else {
              console.error('Owl Carousel plugin is not loaded. Initialization failed.');
          }

          if ($.fn.fancybox) {
              $('[data-fancybox="gallery"]').fancybox({
                  buttons: ["slideShow", "fullScreen", "thumbs", "close"]
              });
              console.log('Fancybox initialized for [data-fancybox="gallery"]');
          } else {
              console.error('Fancybox plugin is not loaded. Initialization failed.');
          }
      } else {
          console.error('jQuery is not loaded. Initialization failed.');
      }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !window.DesignMode) return;
  try {
    
  function initializeShopCatSlider() {
    // Check if jQuery and Owl Carousel plugin are loaded
    if (window.jQuery && jQuery.fn.owlCarousel) {
      const $shopCatSlider = $('.shop-cat-slider');

      // Ensure the element exists before initializing
      if ($shopCatSlider.length) {
        if (!$shopCatSlider.hasClass('owl-loaded')) { // Prevent reinitialization
          $shopCatSlider.owlCarousel({
            loop: true,
            margin: 10,
            responsiveClass: true,
            nav: false,
            dots: false,
            responsive: {
              0: {
                items: 3.5,
                nav: false
              },
              600: {
                items: 5.5,
                nav: false
              },
              1000: {
                items: 9,
                nav: false
              }
            }
          });

          console.log('Owl Carousel initialized for .shop-cat-slider');
        } else {
          console.log('.shop-cat-slider is already initialized.');
        }
      } else {
        console.warn('.shop-cat-slider element not found.');
      }
    } else {
      console.error('jQuery or Owl Carousel plugin is not loaded. Retrying initialization...');
      setTimeout(initializeShopCatSlider, 100); // Retry after 100ms
    }
  }

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initializeShopCatSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-concerns"] && !window.DesignMode) return;
  try {
    
  function initializeConcernBlockSlider() {
    // Check if jQuery and Owl Carousel are loaded
    if (window.jQuery && jQuery.fn.owlCarousel) {
      const $concernBlockSlider = $('.concern-block-slider');

      // Ensure the element exists before initializing
      if ($concernBlockSlider.length) {
        if (!$concernBlockSlider.hasClass('owl-loaded')) { // Prevent reinitialization
          $concernBlockSlider.owlCarousel({
            loop: true,
            margin: 10,
            responsiveClass: true,
            nav: false,
            dots: false,
            responsive: {
              0: {
                items: 1,
                nav: false,
                dots: true
              },
              600: {
                items: 1,
                nav: false,
                dots: true
              },
              1000: {
                items: 3,
                nav: false
              }
            }
          });

          console.log('Owl Carousel initialized for .concern-block-slider');
        } else {
          console.log('.concern-block-slider is already initialized.');
        }
      } else {
        console.warn('.concern-block-slider element not found.');
      }
    } else {
      console.error('jQuery or Owl Carousel plugin is not loaded. Retrying initialization...');
      setTimeout(initializeConcernBlockSlider, 100); // Retry after 100ms
    }
  }

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initializeConcernBlockSlider);

  } catch(e) { console.error(e); }
})();
})();
